import { createSlice } from "@reduxjs/toolkit";
import { AuthStoreState } from "./types";

// // // //

const initialState: AuthStoreState = {
    isRegistrationModalOpen: false,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        openRegistrationModal: (state) => {
            state.isRegistrationModalOpen = true;
        },
        closeRegistrationModal: (state) => {
            state.isRegistrationModalOpen = false;
        },
    },
});

export const { openRegistrationModal, closeRegistrationModal } =
    authSlice.actions;
export const reducer = authSlice.reducer;
